<template>
  <div id="dashboard-tab">
    <div class="d-flex justify-content-between align-items-center flex-lg-row flex-column">
      <img class="w-100" src="/images/recr-5.png"/>

      <div class="description ml-md-5 ml-0 text-left px-3 px-md-0">
        <div class="title font-avenir mb-3">Employee dashboard</div>
        <p>Maintain personal connections by seeing which of your team members have check-in and their activity streams.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
#dashboard-tab {
  .mobile-view {
    @media (max-width: 768px) {
      width: 100%;
    }
  }

  .description {
    @media (max-width: 768px) {
      margin-top: 25px;
    }

    .title {
      color: #303030;
      font-size: 38px;
      font-weight: 800;
      letter-spacing: 0;
      line-height: 46px;
      @media (max-width: 768px) {
        font-size: 28px;
      }
    }

    p {
      color: #505a63;
      font-family: "Open Sans", sans-serif;
      font-size: 16px;
      letter-spacing: 0;
      line-height: 24px;
    }

    .title-2 {
      font-size: 20px;
      font-weight: 800;
      letter-spacing: 0;
      line-height: 28px;
    }

    .list-order {
      background-color: #0db4e6;
      border-radius: 50%;
      width: 40px;
      height: 40px;
      padding: 10px;
      margin-right: 22px;
      text-align: center;

      color: #fff;
      font-size: 16px;
      font-weight: 800;
      letter-spacing: 0;
      line-height: 22px;
    }

    .step-content {
      width: 440px;

      @media (max-width: 768px) {
        width: 100%;
      }
    }
  }

  .word-with-line {
    text-align: center;
    border-bottom: 1px dashed #000;
    line-height: 0.1em;
    position: relative;
    font-size: 16px;
    color: "#808FA4";

    .circle {
      width: 8px;
      height: 8px;
      background: red;
      border-radius: 50%;
      position: absolute;
      top: -2px;
    }

    span {
      background: #fff;
      padding: 0 10px;
    }
  }

  .steps {
    margin-top: 24px;
  }
}
</style>
